module.exports = __webpack_public_path__ + "media/images/lb/690-f902dc9c6646257606989c458eda57fc.svg";